export default __webpack_public_path__ + "static/pp-punga-e63fb716c970b009c082385b5e879575.jpg";